export const focusStyle =
  'focus:ring-2 focus:ring-action-focused ring-offset-1 ring-offset-surface-base';

export const activeStyle =
  'active:ring-2 active:ring-action-focused ring-offset-1 ring-offset-surface-base';
